// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"537b26d9","476":"132815a6","765":"de226f79","916":"79e0d767"}[chunkId] + ".chunk.js";
};